"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaFetchAgent = void 0;

var tslib_1 = require("tslib");

var dataloader_1 = tslib_1.__importDefault(require("dataloader"));

var graphql_request_1 = require("graphql-request");

var address_1 = require("@ethersproject/address");

var RequestError_1 = require("./RequestError");

var urls_1 = require("../constants/urls");

var zora_graph_1 = require("../graph-queries/zora-graph");

var uniswap_1 = require("../graph-queries/uniswap");

var timeouts_1 = require("../constants/timeouts");

var TransformFetchResults_1 = require("./TransformFetchResults");

var FetchWithTimeout_1 = require("./FetchWithTimeout");

var OpenseaUtils_1 = require("./OpenseaUtils");

var zora_indexer_1 = require("../graph-queries/zora-indexer");

var ens_graph_1 = require("../graph-queries/ens-graph");

var ErrorUtils_1 = require("./ErrorUtils");

var UriUtils_1 = require("./UriUtils");
/**
 * Internal agent for NFT Hooks to fetch NFT information.
 * Can be used directly for interaction with non-react web frameworks or server frameworks.
 * Uses a cached promise-based API.
 * Fetches from IPFS providers and thegraph.
 */


var MediaFetchAgent = /*#__PURE__*/function () {
  function MediaFetchAgent(network) {
    var _this = this;

    _classCallCheck(this, MediaFetchAgent);

    this.timeouts = timeouts_1.DEFAULT_NETWORK_TIMEOUTS_MS;
    this.networkId = network;
    this.loaders = {
      mediaLoader: new dataloader_1.default(function (keys) {
        return _this.fetchMediaGraph(keys);
      }, {
        cache: false
      }),
      currencyLoader: new dataloader_1.default(function (keys) {
        return _this.fetchCurrenciesGraph(keys);
      }, {
        cache: false
      }),
      zoraNFTIndexerLoader: new dataloader_1.default(function (keys) {
        return _this.fetchZoraNFTIndexerNFTs(keys);
      }),
      usernameLoader: new dataloader_1.default(function (keys) {
        return _this.fetchZoraUsernames(keys);
      }),
      genericNFTLoader: new dataloader_1.default(function (keys) {
        return _this.fetchGenericNFT(keys);
      }, {
        cache: false,
        maxBatchSize: 30
      }),
      ensLoader: new dataloader_1.default(function (keys) {
        return _this.loadEnsBatch(keys);
      }, {
        maxBatchSize: 400
      }),
      auctionInfoLoader: new dataloader_1.default(function (keys) {
        return _this.fetchAuctionNFTInfo(keys);
      }, {
        cache: false,
        maxBatchSize: 300
      })
    };
  }
  /**
   * Clear all cached responses from metadata, currency, and NFT chain information loaders
   */


  _createClass(MediaFetchAgent, [{
    key: "clearCache",
    value: function clearCache() {
      Object.values(this.loaders).forEach(function (loader) {
        return loader.clearAll();
      });
    }
    /**
     * Gets information of currencies and trading prices from uniswap
     * @param currencies list of currency contract ids on ethereum
     * @returns Promise<CurrencyLookupType>
     */

  }, {
    key: "loadCurrencies",
    value: function () {
      var _loadCurrencies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currencies) {
        var results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loaders.currencyLoader.loadMany(currencies);

              case 2:
                results = _context.sent;
                return _context.abrupt("return", results.reduce(function (last, result) {
                  if (!(result instanceof Error)) {
                    last[result.token.id] = result;
                  }

                  return last;
                }, {}));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadCurrencies(_x) {
        return _loadCurrencies.apply(this, arguments);
      }

      return loadCurrencies;
    }()
    /**
     * Fetch NFT content or retun URI if content shouild not be fetched
     * @param url NFT Content URL
     * @param contentType string mime type to fetch
     * @returns Promise<MediaContentType> Media content information or URL
     */

  }, {
    key: "fetchContent",
    value: function () {
      var _fetchContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, contentType) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!contentType.startsWith('text/')) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.IPFS).fetch(UriUtils_1.convertURIToHTTPS(url));

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.text();

              case 7:
                _context2.t0 = _context2.sent;
                _context2.t1 = contentType;
                return _context2.abrupt("return", {
                  text: _context2.t0,
                  type: 'text',
                  mimeType: _context2.t1
                });

              case 12:
                _context2.prev = 12;
                _context2.t2 = _context2["catch"](1);
                throw new RequestError_1.RequestError('Issue fetching IPFS data', _context2.t2);

              case 15:
                return _context2.abrupt("return", {
                  uri: url,
                  type: 'uri',
                  mimeType: contentType
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12]]);
      }));

      function fetchContent(_x2, _x3) {
        return _fetchContent.apply(this, arguments);
      }

      return fetchContent;
    }()
    /**
     * Fetch Content MIME type from content URI
     *
     * @param url IPFS Content URI
     * @returns mime type as a string
     * @throws RequestError
     */

  }, {
    key: "fetchContentMimeType",
    value: function () {
      var _fetchContentMimeType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
        var response, header;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.IPFS).fetch(url, {
                  method: 'HEAD'
                });

              case 2:
                response = _context3.sent;
                header = response.headers.get('content-type');

                if (header) {
                  _context3.next = 6;
                  break;
                }

                throw new RequestError_1.RequestError('No content type returned for URI');

              case 6:
                return _context3.abrupt("return", header);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchContentMimeType(_x4) {
        return _fetchContentMimeType.apply(this, arguments);
      }

      return fetchContentMimeType;
    }()
    /**
     * Un-batched fetch function to fetch a group of ZNFT data
     *
     * @param ids list of ids to query
     * @param type type of ids: creator, id (of media), owner
     * @returns
     */

  }, {
    key: "fetchZNFTGroupData",
    value: function () {
      var _fetchZNFTGroupData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ids, type) {
        var _this2 = this;

        var fetchWithTimeout, client, getQuery, response, medias;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.THEGRAPH_API_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });

                getQuery = function getQuery() {
                  var base = {
                    id_ids: [],
                    creator_ids: [],
                    owner_ids: []
                  };
                  var idsNormalized = ids.map(function (id) {
                    return id.toLowerCase();
                  });

                  switch (type) {
                    case 'id':
                      base.id_ids = idsNormalized;
                      break;

                    case 'creator':
                      base.creator_ids = idsNormalized;
                      break;

                    case 'owner':
                      base.owner_ids = idsNormalized;
                      break;
                  }

                  return base;
                };

                _context4.next = 5;
                return client.request(zora_graph_1.GET_MEDIAS_QUERY, getQuery);

              case 5:
                response = _context4.sent;
                medias = [].concat(_toConsumableArray(response.creator), _toConsumableArray(response.owner), _toConsumableArray(response.id));
                return _context4.abrupt("return", medias.map(function (media) {
                  return TransformFetchResults_1.transformMediaItem(media, _this2.networkId);
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchZNFTGroupData(_x5, _x6) {
        return _fetchZNFTGroupData.apply(this, arguments);
      }

      return fetchZNFTGroupData;
    }()
  }, {
    key: "loadEnsBatch",
    value: function () {
      var _loadEnsBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(addresses) {
        var fetchWithTimeout, client, ensResponse;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.ENS_GRAPH_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context5.next = 4;
                return client.request(ens_graph_1.RESOLVE_ENS_FROM_ADDRESS_QUERY, {
                  addresses: addresses.map(function (address) {
                    return address.toLowerCase();
                  })
                });

              case 4:
                ensResponse = _context5.sent;
                return _context5.abrupt("return", addresses.map(function (address) {
                  return ensResponse.domains.find(function (domain) {
                    var _a;

                    return ((_a = domain.resolvedAddress) === null || _a === void 0 ? void 0 : _a.id.toLowerCase()) === address.toLowerCase();
                  }) || new Error('Not found');
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadEnsBatch(_x7) {
        return _loadEnsBatch.apply(this, arguments);
      }

      return loadEnsBatch;
    }() // Alpha: uses zora indexer
    // format CONTRACT_ID-TOKEN_ID

  }, {
    key: "fetchZoraNFTIndexerNFTs",
    value: function () {
      var _fetchZoraNFTIndexerNFTs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(keys) {
        var fetchWithTimeout, client, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.ZoraIndexer);
                client = new graphql_request_1.GraphQLClient(urls_1.ZORA_INDEXER_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context6.next = 4;
                return client.request(zora_indexer_1.BY_IDS, {
                  ids: keys
                });

              case 4:
                response = _context6.sent;
                return _context6.abrupt("return", keys.map(function (key) {
                  return response.Token.find(function (token) {
                    return token.id === key;
                  }) || new ErrorUtils_1.NotFoundError('Did not find token');
                }));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchZoraNFTIndexerNFTs(_x8) {
        return _fetchZoraNFTIndexerNFTs.apply(this, arguments);
      }

      return fetchZoraNFTIndexerNFTs;
    }()
  }, {
    key: "loadZoraNFTIndexerNFTUntransformed",
    value: function () {
      var _loadZoraNFTIndexerNFTUntransformed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(contractAddress, tokenId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.loaders.zoraNFTIndexerLoader.load("".concat(address_1.getAddress(contractAddress), "-").concat(tokenId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loadZoraNFTIndexerNFTUntransformed(_x9, _x10) {
        return _loadZoraNFTIndexerNFTUntransformed.apply(this, arguments);
      }

      return loadZoraNFTIndexerNFTUntransformed;
    }()
  }, {
    key: "loadZoraNFTIndexerNFTsUntransformed",
    value: function () {
      var _loadZoraNFTIndexerNFTsUntransformed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(tokenAndIds) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.loaders.zoraNFTIndexerLoader.loadMany(tokenAndIds));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function loadZoraNFTIndexerNFTsUntransformed(_x11) {
        return _loadZoraNFTIndexerNFTsUntransformed.apply(this, arguments);
      }

      return loadZoraNFTIndexerNFTsUntransformed;
    }()
    /**
     * Un-batched fetch function to fetch a group of NFT data from the zora indexer
     *
     * @param collectionAddresses list of collections to include
     * @param curatorAddress curator to query
     * @param approved boolean if the auction is approved (null for approved and un-approved auctions)
     */

  }, {
    key: "fetchZoraIndexerGroupData",
    value: function () {
      var _fetchZoraIndexerGroupData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref) {
        var collectionAddresses, curatorAddress, _ref$approved, approved, _ref$onlyAuctions, onlyAuctions, _ref$limit, limit, _ref$offset, offset, queryStatement, addresses, approvedStatement, auctionsQueryStmt, fetchWithTimeout, client;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                collectionAddresses = _ref.collectionAddresses, curatorAddress = _ref.curatorAddress, _ref$approved = _ref.approved, approved = _ref$approved === void 0 ? null : _ref$approved, _ref$onlyAuctions = _ref.onlyAuctions, onlyAuctions = _ref$onlyAuctions === void 0 ? false : _ref$onlyAuctions, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 200 : _ref$limit, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset;

                if (!(!(collectionAddresses === null || collectionAddresses === void 0 ? void 0 : collectionAddresses.length) && !curatorAddress)) {
                  _context9.next = 3;
                  break;
                }

                throw new ErrorUtils_1.ArgumentsError('Needs to have at least one curator or collector');

              case 3:
                if (!(!onlyAuctions && approved !== null)) {
                  _context9.next = 5;
                  break;
                }

                throw new ErrorUtils_1.ArgumentsError('approved=true or approved=false and onlyAuctions=false cannot be set at the same time for fetchZoraIndexerGroupData');

              case 5:
                queryStatement = [];

                if (collectionAddresses) {
                  addresses = collectionAddresses.map(function (address) {
                    return address_1.getAddress(address);
                  });
                  queryStatement.push({
                    address: {
                      _in: addresses
                    }
                  });
                }

                approvedStatement = undefined;

                if (approved !== null) {
                  approvedStatement = {
                    approved: {
                      _eq: approved
                    }
                  };
                }

                if (curatorAddress) {
                  queryStatement.push({
                    auctions: _objectSpread({
                      curator: {
                        _eq: curatorAddress
                      }
                    }, approvedStatement)
                  });
                } else if (approvedStatement || onlyAuctions) {
                  auctionsQueryStmt = {};

                  if (onlyAuctions) {
                    auctionsQueryStmt = {
                      _not: {}
                    };
                  }

                  queryStatement.push({
                    auctions: _objectSpread(_objectSpread({}, auctionsQueryStmt), approvedStatement)
                  });
                }

                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.ZoraIndexer);
                client = new graphql_request_1.GraphQLClient(urls_1.ZORA_INDEXER_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context9.next = 14;
                return client.request(zora_indexer_1.ACTIVE_AUCTIONS_QUERY, {
                  andQuery: queryStatement,
                  offset: offset,
                  limit: limit
                });

              case 14:
                return _context9.abrupt("return", _context9.sent.Token);

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchZoraIndexerGroupData(_x12) {
        return _fetchZoraIndexerGroupData.apply(this, arguments);
      }

      return fetchZoraIndexerGroupData;
    }()
    /**
     * Un-batched fetch function to fetch a group of NFT data from the zora indexer
     *
     * @param collectionAddresses list of addresses for collection
     * @param userAddress address of user
     * @param type type of ids: creator, id (of media), owner
     * @returns
     */

  }, {
    key: "fetchZoraIndexerUserOwnedNFTs",
    value: function () {
      var _fetchZoraIndexerUserOwnedNFTs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref2) {
        var collectionAddresses, userAddress, _ref2$offset, offset, _ref2$limit, limit, fetchWithTimeout, client, addressQueryPart, response;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                collectionAddresses = _ref2.collectionAddresses, userAddress = _ref2.userAddress, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? 0 : _ref2$offset, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 250 : _ref2$limit;
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.ZoraIndexer);
                client = new graphql_request_1.GraphQLClient(urls_1.ZORA_INDEXER_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                addressQueryPart = {};

                if (collectionAddresses === null || collectionAddresses === void 0 ? void 0 : collectionAddresses.length) {
                  addressQueryPart['_in'] = collectionAddresses.map(address_1.getAddress);
                }

                _context10.next = 7;
                return client.request(zora_indexer_1.BY_OWNER, {
                  addressQueryPart: addressQueryPart,
                  owner: address_1.getAddress(userAddress),
                  offset: offset,
                  limit: limit
                });

              case 7:
                response = _context10.sent;
                return _context10.abrupt("return", response.Token);

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchZoraIndexerUserOwnedNFTs(_x13) {
        return _fetchZoraIndexerUserOwnedNFTs.apply(this, arguments);
      }

      return fetchZoraIndexerUserOwnedNFTs;
    }()
    /**
     * Get on-chain ZORA NFT ID associated media information
     *
     * @param mediaId ZORA NFT id to retrieve information of
     * @returns Promise<NFTDataType> On-chain NFT data
     */

  }, {
    key: "loadZNFTData",
    value: function () {
      var _loadZNFTData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(mediaId) {
        var currencyInfos,
            chainInfo,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                currencyInfos = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
                _context11.next = 3;
                return this.loaders.mediaLoader.load(mediaId);

              case 3:
                chainInfo = _context11.sent;

                if (chainInfo) {
                  _context11.next = 6;
                  break;
                }

                throw new RequestError_1.RequestError('Cannot fetch chain information');

              case 6:
                return _context11.abrupt("return", _objectSpread(_objectSpread({}, chainInfo), {}, {
                  pricing: TransformFetchResults_1.addAuctionInformation(chainInfo.pricing, currencyInfos)
                }));

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function loadZNFTData(_x14) {
        return _loadZNFTData.apply(this, arguments);
      }

      return loadZNFTData;
    }()
  }, {
    key: "loadNFTData",
    value: function () {
      var _loadNFTData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(contractAddress, tokenId, auctionData, currencyData) {
        var contractAndToken, nftInfo;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                contractAndToken = "".concat(contractAddress.toLowerCase(), ":").concat(tokenId);
                _context12.next = 3;
                return this.loaders.genericNFTLoader.load(contractAndToken);

              case 3:
                nftInfo = _context12.sent;

                if (auctionData) {
                  _context12.next = 14;
                  break;
                }

                _context12.prev = 5;
                _context12.next = 8;
                return this.loadAuctionInfo(contractAddress, tokenId);

              case 8:
                auctionData = _context12.sent;
                _context12.next = 14;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12["catch"](5);

                if (!(_context12.t0 instanceof ErrorUtils_1.NotFoundError)) {
                  // Log any not-found error
                  console.error(_context12.t0);
                }

              case 14:
                if (nftInfo) {
                  _context12.next = 16;
                  break;
                }

                throw new RequestError_1.RequestError('Cannot fetch NFT information');

              case 16:
                return _context12.abrupt("return", OpenseaUtils_1.transformOpenseaResponse(nftInfo, auctionData, currencyData));

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[5, 11]]);
      }));

      function loadNFTData(_x15, _x16, _x17, _x18) {
        return _loadNFTData.apply(this, arguments);
      }

      return loadNFTData;
    }()
  }, {
    key: "loadNFTDataUntransformed",
    value: function () {
      var _loadNFTDataUntransformed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(contractAddress, tokenId) {
        var contractAndToken, nftInfo;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                contractAndToken = "".concat(contractAddress.toLowerCase(), ":").concat(tokenId);
                _context13.next = 3;
                return this.loaders.genericNFTLoader.load(contractAndToken);

              case 3:
                nftInfo = _context13.sent;

                if (nftInfo) {
                  _context13.next = 6;
                  break;
                }

                throw new RequestError_1.RequestError('Cannot fetch NFT information');

              case 6:
                return _context13.abrupt("return", nftInfo);

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function loadNFTDataUntransformed(_x19, _x20) {
        return _loadNFTDataUntransformed.apply(this, arguments);
      }

      return loadNFTDataUntransformed;
    }()
  }, {
    key: "loadZNFTDataUntransformed",
    value: function () {
      var _loadZNFTDataUntransformed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(mediaId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.loaders.mediaLoader.load(mediaId);

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function loadZNFTDataUntransformed(_x21) {
        return _loadZNFTDataUntransformed.apply(this, arguments);
      }

      return loadZNFTDataUntransformed;
    }()
  }, {
    key: "loadAuctionInfo",
    value: function () {
      var _loadAuctionInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(tokenContract, tokenId) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.loaders.auctionInfoLoader.load([tokenContract.toLowerCase(), tokenId].join('-'));

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function loadAuctionInfo(_x22, _x23) {
        return _loadAuctionInfo.apply(this, arguments);
      }

      return loadAuctionInfo;
    }() // use dash between lowercase contract id and token id

  }, {
    key: "loadAuctionInfos",
    value: function () {
      var _loadAuctionInfos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(tokenContractAndIds) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.loaders.auctionInfoLoader.loadMany(tokenContractAndIds);

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function loadAuctionInfos(_x24) {
        return _loadAuctionInfos.apply(this, arguments);
      }

      return loadAuctionInfos;
    }()
    /**
     *
     * @param address string address of username to load
     * @returns
     */

  }, {
    key: "loadUsername",
    value: function () {
      var _loadUsername = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(address) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.loaders.usernameLoader.load(address.toLowerCase()));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function loadUsername(_x25) {
        return _loadUsername.apply(this, arguments);
      }

      return loadUsername;
    }()
  }, {
    key: "loadEnsName",
    value: function () {
      var _loadEnsName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(address) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.loaders.ensLoader.load(address.toLowerCase()));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function loadEnsName(_x26) {
        return _loadEnsName.apply(this, arguments);
      }

      return loadEnsName;
    }()
    /**
     * Fetch function to retrieve Graph data for matching curated auctions
     * This function is not cached
     *
     * @function fetchReserveAuctions
     * @private
     * @param curatorIds list of Zora NFT IDs to fetch from the graph datastore
     * @returns mapped transformed list of curated auction results
     */

  }, {
    key: "fetchReserveAuctions",
    value: function () {
      var _fetchReserveAuctions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(curatorIds) {
        var isApproved,
            first,
            skip,
            fetchWithTimeout,
            client,
            query,
            response,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                isApproved = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
                first = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : 1000;
                skip = _args19.length > 3 && _args19[3] !== undefined ? _args19[3] : 0;
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.THEGRAPH_API_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                query = zora_graph_1.GET_ALL_AUCTIONS;

                if (curatorIds.length) {
                  query = zora_graph_1.GET_AUCTION_BY_CURATOR;
                }

                _context19.next = 9;
                return client.request(query, {
                  curators: curatorIds.length ? curatorIds : undefined,
                  first: first,
                  skip: skip,
                  approved: isApproved === null ? [true, false] : [isApproved]
                });

              case 9:
                response = _context19.sent;
                return _context19.abrupt("return", response.reserveAuctions);

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function fetchReserveAuctions(_x27) {
        return _fetchReserveAuctions.apply(this, arguments);
      }

      return fetchReserveAuctions;
    }()
  }, {
    key: "fetchAuctionNFTInfo",
    value: function () {
      var _fetchAuctionNFTInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(tokenAndAddresses) {
        var fetchWithTimeout, client, response;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.THEGRAPH_API_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context20.next = 4;
                return client.request(zora_graph_1.GET_AUCTION_BY_MEDIA, {
                  tokens: tokenAndAddresses.map(function (tokenAndAddress) {
                    return tokenAndAddress.toLowerCase();
                  })
                });

              case 4:
                response = _context20.sent;

                if (response.reserveAuctions) {
                  _context20.next = 7;
                  break;
                }

                throw new RequestError_1.RequestError('Missing auction in reponse');

              case 7:
                return _context20.abrupt("return", tokenAndAddresses.map(function (tokenAndAddress) {
                  return response.reserveAuctions.find(function (auction) {
                    return auction.token === tokenAndAddress;
                  }) || new ErrorUtils_1.NotFoundError('Missing Auction');
                }));

              case 8:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function fetchAuctionNFTInfo(_x28) {
        return _fetchAuctionNFTInfo.apply(this, arguments);
      }

      return fetchAuctionNFTInfo;
    }()
    /**
     * Internal fetch current auctions by curator
     *
     * @function fetchMediaGraph
     * @private
     * @param mediaIds list of Zora NFT IDs to fetch from the graph datastore
     * @returns mapped transformed list of zora NFT ID data
     */

  }, {
    key: "fetchMediaGraph",
    value: function () {
      var _fetchMediaGraph = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(mediaIds) {
        var _this3 = this;

        var fetchWithTimeout, client, response;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.THEGRAPH_API_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context21.next = 4;
                return client.request(zora_graph_1.GET_MEDIAS_QUERY, {
                  id_ids: mediaIds,
                  creator_ids: [],
                  owner_ids: []
                });

              case 4:
                response = _context21.sent;
                return _context21.abrupt("return", mediaIds.map(function (key) {
                  return TransformFetchResults_1.transformMediaForKey(response, key, _this3.networkId);
                }));

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function fetchMediaGraph(_x29) {
        return _fetchMediaGraph.apply(this, arguments);
      }

      return fetchMediaGraph;
    }()
    /**
     * Fetches generic NFT information
     *
     * @param nftAddresses list of addresses in a 0xcontractid:tokenid format
     * @returns
     */

  }, {
    key: "fetchGenericNFT",
    value: function () {
      var _fetchGenericNFT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(nftAddresses) {
        var fetchWithTimeout, apiBase, urlParams, response, responseJson;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.OpenSea);
                apiBase = urls_1.OPENSEA_API_URL_BY_NETWORK[this.networkId];
                urlParams = [];
                nftAddresses.map(function (address) {
                  return address.split(':');
                }).forEach(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      address = _ref4[0],
                      tokenId = _ref4[1];

                  urlParams.push("token_ids=".concat(tokenId, "&asset_contract_addresses=").concat(address));
                });
                _context22.next = 6;
                return fetchWithTimeout.fetch("".concat(apiBase, "assets?").concat(urlParams.join('&'), "&order_direction=desc&offset=0&limit=50"));

              case 6:
                response = _context22.sent;
                _context22.next = 9;
                return response.json();

              case 9:
                responseJson = _context22.sent;
                return _context22.abrupt("return", nftAddresses.map(function (nftAddress) {
                  return OpenseaUtils_1.transformGenericNFTForKey(responseJson.assets, nftAddress);
                }));

              case 11:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function fetchGenericNFT(_x30) {
        return _fetchGenericNFT.apply(this, arguments);
      }

      return fetchGenericNFT;
    }()
    /**
     * Fetches zora username information from blockchain addresses for displaying user
     * information.
     *
     * @param addresses string list of addresses to map to Zora usernames
     * @returns list of UsernameResponseType - all fields are optional except address
     */

  }, {
    key: "fetchZoraUsernames",
    value: function () {
      var _fetchZoraUsernames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(addresses) {
        var fetchWithTimeout, response, usernames;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Zora);
                _context23.next = 3;
                return fetchWithTimeout.fetch(urls_1.ZORA_USERNAME_API_URL, {
                  method: 'POST',
                  type: 'cors',
                  headers: {
                    'content-type': 'application/json'
                  },
                  body: JSON.stringify({
                    addresses: addresses
                  })
                });

              case 3:
                response = _context23.sent;
                _context23.next = 6;
                return response.json();

              case 6:
                usernames = _context23.sent;
                return _context23.abrupt("return", addresses.map(function (address) {
                  var foundUsername = usernames.find(function (username) {
                    return username.address.toLowerCase() === address;
                  });

                  if (foundUsername) {
                    return foundUsername;
                  }

                  return {
                    address: address
                  };
                }));

              case 8:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function fetchZoraUsernames(_x31) {
        return _fetchZoraUsernames.apply(this, arguments);
      }

      return fetchZoraUsernames;
    }()
    /**
     * Internal fetch function to retrieve currency information from TheGraph
     *
     * @function fetchCurrenciesGraph
     * @private
     * @param currencyContracts list of Ethereum addresses of currency contract data to retrieve
     * @returns mapped transformed list of ETH currency mapping data
     */

  }, {
    key: "fetchCurrenciesGraph",
    value: function () {
      var _fetchCurrenciesGraph = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(currencyContracts) {
        var fetchWithTimeout, client, currencies;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                fetchWithTimeout = new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.Graph);
                client = new graphql_request_1.GraphQLClient(urls_1.THEGRAPH_UNISWAP_URL_BY_NETWORK[this.networkId], {
                  fetch: fetchWithTimeout.fetch
                });
                _context24.next = 4;
                return client.request(uniswap_1.GET_TOKEN_VALUES_QUERY, {
                  currencyContracts: currencyContracts.filter(function (contract) {
                    return contract !== TransformFetchResults_1.NULL_ETH_CURRENCY_ID;
                  })
                });

              case 4:
                currencies = _context24.sent;
                return _context24.abrupt("return", currencyContracts.map(function (key) {
                  return TransformFetchResults_1.transformCurrencyForKey(currencies, key);
                }));

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function fetchCurrenciesGraph(_x32) {
        return _fetchCurrenciesGraph.apply(this, arguments);
      }

      return fetchCurrenciesGraph;
    }()
    /**
     * Fetch method to query metadata from IPFS. Not cached
     *
     * @function fetchIPFSMetadataCached
     * @public
     * @param url Metadata Source
     * @returns IPFS Metadata Fetch
     * @throws RequestError
     */

  }, {
    key: "fetchIPFSMetadata",
    value: function () {
      var _fetchIPFSMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(url) {
        var request;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return new FetchWithTimeout_1.FetchWithTimeout(this.timeouts.IPFS, 'application/json').fetch(UriUtils_1.convertURIToHTTPS(url));

              case 2:
                request = _context25.sent;
                _context25.prev = 3;
                _context25.next = 6;
                return request.json();

              case 6:
                return _context25.abrupt("return", _context25.sent);

              case 9:
                _context25.prev = 9;
                _context25.t0 = _context25["catch"](3);
                throw new RequestError_1.RequestError('Cannot read JSON metadata from IPFS', _context25.t0);

              case 12:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[3, 9]]);
      }));

      function fetchIPFSMetadata(_x33) {
        return _fetchIPFSMetadata.apply(this, arguments);
      }

      return fetchIPFSMetadata;
    }()
  }]);

  return MediaFetchAgent;
}();

exports.MediaFetchAgent = MediaFetchAgent;